import axios from "axios";
import crypto from "@/store/crypto";

// API Configuration Constants
const API_CONFIG = {
  // PRODUCTION_URL: "http://localhost:8000/",

  PRODUCTION_URL: "https://api.nbesf.ir/",

  // BILLS_DOWNLOAD_URL: "http://localhost:8000/storage/extracted_plates/bill",
  // ADJUSTMENT_DOWNLOAD_URL: "http://localhost:8000/storage/extracted_plates/adjustment",

  BILLS_DOWNLOAD_URL: "https://api.nbesf.ir/storage/extracted_plates/bill",
  ADJUSTMENT_DOWNLOAD_URL: "https://api.nbesf.ir/storage/extracted_plates/adjustment",
};

/**
 * Default Axios Configuration
 */
const defaultConfig = {
  baseURL: API_CONFIG.PRODUCTION_URL,
  withCredentials: true,
  withXSRFToken: true,
  headers: {
    common: {
      Authorization: `Bearer ${crypto.getData("token")}`,
    },
  },
};

/**
 * Create Axios Instance
 */
const api = axios.create(defaultConfig);

/**
 * Request Interceptor
 * Ensures the latest token is always used in requests
 */
const requestInterceptor = (config) => {
  const token = crypto.getData("token");
  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }
  return config;
};

const requestErrorHandler = (error) => {
  return Promise.reject(error);
};

// Apply interceptors
api.interceptors.request.use(requestInterceptor, requestErrorHandler);

// Export constants
export const billsDownloadApi = API_CONFIG.BILLS_DOWNLOAD_URL;
export const adjustmentsDownloadApi = API_CONFIG.ADJUSTMENT_DOWNLOAD_URL;
export const siteURL = API_CONFIG.PRODUCTION_URL
export default api;
